function isLandscape() {
  return window.innerWidth > window.innerHeight;
}

(function flexible (window, document) {
  let docEl = document.documentElement
  let dpr = window.devicePixelRatio || 1

  // adjust body font size
  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit () {
    console.log(docEl.clientWidth);
    let rem = docEl.clientWidth / 10;
    // // 初步定义600为pad
    if (docEl.clientWidth >= 600 && docEl.clientWidth < 1024) {
      rem = docEl.clientWidth / 20;
    // pc
    } else if (docEl.clientWidth >= 1024) {
      rem = 1000 / 20;
    }
    // 如果是题库页面且是横屏且是pad,横屏时计算的值和设计稿不一致，需要缩小0.75倍
    if (window.location.pathname.includes('/quiz') && isLandscape()) {
      rem = docEl.clientWidth / 20 * 0.75;
      console.log(rem, 'rem*0.75');
      // 如果是非 pad
      if (docEl.clientWidth < 1000 && docEl.clientHeight <= 500) {
        rem = docEl.clientWidth / 20;
        console.log(rem, 'rem');
      }
    }
    docEl.style.fontSize = rem + 'px'
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    let fakeBody = document.createElement('body')
    let testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document))
